import { render, staticRenderFns } from "./tempcarbill-.vue?vue&type=template&id=35737c55&scoped=true&"
import script from "./tempcarbill-.vue?vue&type=script&lang=js&"
export * from "./tempcarbill-.vue?vue&type=script&lang=js&"
import style0 from "./tempcarbill-.vue?vue&type=style&index=0&id=35737c55&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35737c55",
  null
  
)

export default component.exports